(()=> {
  if (window.matchMedia('(max-width: 990px)')) {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
})()
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : openDetailsElement.removeAttribute('open');
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if (!isOpen) {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
        }, 10);
      } else {
        detailsElement.classList.remove('menu-opening');
        summaryElement.setAttribute('aria-expanded', false);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');

    this.mainDetailsToggle.querySelectorAll('summary').forEach((summary) => {
      summary.setAttribute('aria-expanded', 'false');
    });

    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement === this.mainDetailsToggle) {
        this.closeMenuDrawer(event, detailsElement.querySelector('summary'));
    } else {
        detailsElement.removeAttribute('open');
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindAccordionEvents();
  }

  bindAccordionEvents() {
    this.querySelectorAll('details.menu-drawer__accordion summary').forEach(summary => {
      summary.addEventListener('click', (event) => {
      });
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    this.header.classList.add('menu-open');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }

  openPage(summaryElement) {
    summaryElement.setAttribute('aria-expanded', true);
  }

  closePage(event) {
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.isDragging = false;
    this.dragStartX = 0;
    this.scrollStartX = 0;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if (window.innerWidth >= 768) {
      this.slider.addEventListener('mousedown', this.onDragStart.bind(this));
      this.slider.addEventListener('mousemove', this.onDragMove.bind(this));
      this.slider.addEventListener('mouseup', this.onDragEnd.bind(this));
      this.slider.addEventListener('mouseleave', this.onDragEnd.bind(this));
      this.slider.addEventListener('touchstart', this.onDragStart.bind(this), { passive: true });
      this.slider.addEventListener('touchmove', this.onDragMove.bind(this), { passive: true });
      this.slider.addEventListener('touchend', this.onDragEnd.bind(this), { passive: true });
    }
  }

  onDragStart(event) {
    if (event.type === 'mousedown' && event.button !== 0) return;

    this.isDragging = true;
    this.dragStartX = event.type.startsWith('touch') ? event.touches[0].clientX : event.clientX;
    this.scrollStartX = this.slider.scrollLeft;
    event.preventDefault();
  }

  onDragMove(event) {
    if (!this.isDragging) return;

    const clientX = event.type.startsWith('touch') ? event.touches[0].clientX : event.clientX;
    const deltaX = clientX - this.dragStartX;
    this.slider.scrollLeft = this.scrollStartX - deltaX * 2.5;
  }

  onDragEnd(event) {
    this.isDragging = false;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class SizeSelects extends VariantSelects {
  constructor() {
    super();

    this.variantsData = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]')
    this.variant = JSON.parse(this.querySelector('[data-selected-variant]')?.textContent || '{}')
    this.section = this.closest('section')
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      this.variant = this.variantsData.find(variant => variant.id == event.target.dataset.variantId)

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          disabledDynamicPrice: true,
          selectedOptionValues: this.selectedOptionValues,
        },
      });

      this.updatePrice();
      this.updateSubscrionBlock()
      this.updateVariantId()
    });

    this.section.addEventListener('selling_plan:changed', event => {
      this.updatePrice()
      this.updateVatiantBlocks()
    })
  }

  getPrice(variant) {
    variant = variant || this.variant

    this.form = this.form || document.getElementById(this.dataset.formId);

    const sellinPlanId = !this.form['selling_plan']?.disabled && this.form['selling_plan']?.value

    if(!sellinPlanId) return variant.price

    return variant.selling_plan_allocations.find(sellingPlan => sellingPlan.selling_plan_id == sellinPlanId)?.price
      || variant.price
  }

  updateVariantId() {
    this.form = this.form || document.getElementById(this.dataset.formId);

    if(this.form['id']) {
      this.form['id'].value = this.variant.id
    }
  }

  getSubscriptionPrice(variant) {
    variant = variant || this.variant

    this.form = this.form || document.getElementById(this.dataset.formId);

    const sellinPlanId = this.form['selling_plan']?.value

    if(!sellinPlanId) return variant.price

    return variant.selling_plan_allocations.find(sellingPlan => sellingPlan.selling_plan_id == sellinPlanId)?.price
      || variant.price
  }

  getVariant(variantId) {
    return this.variantsData.find(variant => variant.id == variantId);
  }

  updateVatiantBlocks() {
    this.variantBlocks = this.variantBlocks || this.querySelectorAll('[data-variant-block]')

    this.variantBlocks.forEach(variantBlock => {
      const variant = this.getVariant(variantBlock.dataset.variantId)

      const elements = {
        discountPercent: variantBlock.querySelector('[data-variant-discount]'),
        discountWrapper: variantBlock.querySelector('[data-variant-discount-wrapper]'),
        pricePerUnit: variantBlock.querySelector('[data-price-per-unit]')
      }


      const price = this.getPrice(variant)
      const discountPercent = Math.round((variant.compare_at_price - price) * 100.0 / variant.compare_at_price)

      elements.discountPercent.innerHTML = discountPercent
      elements.discountWrapper.classList.toggle('hidden', variant.compare_at_price <= price)

      elements.pricePerUnit.innerHTML = window.Shopify.formatMoney(price / elements.pricePerUnit.dataset.quantity)
    })
  }

  updatePrice() {
    const currentPrice = this.getPrice()
    const subscriptionPrice = this.getSubscriptionPrice()


    this.priceWrapperElements = this.priceWrapperElements || this.closest('product-info')?.querySelectorAll('[data-price-wrapper]')

    this.priceWrapperElements.forEach(priceWrapperElement => {
      const priceElement = priceWrapperElement.querySelector('[data-price]')
      const comparePriceElement = priceWrapperElement.querySelector('[data-compare-price]')

      const compareAtPrice = this.variant.compare_at_price || this.variant.price
      let price = priceElement.hasAttribute('data-price-type')
        ? priceElement.dataset.priceType == "subscription"
          ? subscriptionPrice
          : this.variant.price
        : currentPrice

      console.log('comparePriceElement', comparePriceElement)
      console.log('this.variant', this.variant)


      priceElement.innerHTML = window.Shopify.formatMoney(price)

      comparePriceElement.innerHTML = window.Shopify.formatMoney(compareAtPrice)

      comparePriceElement.classList.toggle('hidden', !compareAtPrice || compareAtPrice <= price)
    })
  }

  updateSubscrionBlock() {
    this.subscriptionBlock = this.subscriptionBlock || this.section.querySelector('subscription-selector')

    const subscriptionDiscountWrapper = this.subscriptionBlock?.querySelector('[data-subscription-discount-wrapper]')
    const subscriptionDiscount = this.subscriptionBlock?.querySelector('[data-subscription-discount]')

    if(!subscriptionDiscount || !subscriptionDiscountWrapper) return

    const subscriptionPrice = this.getSubscriptionPrice()
    const discountPercent = Math.round((this.variant.price - subscriptionPrice) * 100.0 / this.variant.price)

    subscriptionDiscount.innerHTML = discountPercent
    subscriptionDiscountWrapper.classList.toggle('hidden', this.variant.price <= subscriptionPrice)
  }
}

customElements.define('size-selects', SizeSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

if (!customElements.get('copy-button')) {
  class CopyButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.copy.bind(this));
    }

    copy() {
      const value = this.getAttribute('data-value');
      if (!value) return;

      navigator.clipboard.writeText(value).then(() => {
        this.classList.add('is-copied');
        this.setFeedback();
      }).catch(err => {
        console.error('Copy failed', err);
      });
    }

    setFeedback() {
      const feedbackText = this.getAttribute('data-feedback');
      const textNode = this.querySelector('[data-copy-text]');
      const trigger = this.querySelector('button');

      if (feedbackText && textNode && trigger) {
        const initialText = textNode.textContent;

        const currentWidth = trigger.getBoundingClientRect().width;
        trigger.style.width = `${currentWidth}px`;
        trigger.style.flexShrink = '0';

        textNode.textContent = feedbackText;

        setTimeout(() => {
          textNode.textContent = initialText;
          this.classList.remove('is-copied');
          trigger.style.width = '';
        }, 2000);
      }
    }
  }

  customElements.define('copy-button', CopyButton);
}

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.dataset.date).getTime();
    this.update();
    setInterval(() => this.update(), 1000);
  }
  update() {
    const now = new Date().getTime();
    const diff = this.endTime - now;
    if (diff < 0) return;

    this.querySelector('[data-days]').innerText = Math.floor(diff / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
    this.querySelector('[data-hours]').innerText = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
    this.querySelector('[data-minutes]').innerText = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
    this.querySelector('[data-seconds]').innerText = Math.floor((diff % (1000 * 60)) / 1000).toString().padStart(2, '0');
  }
}
customElements.define('countdown-timer', CountdownTimer);



// SWIPER INIT

class SwiperConfigurator {
  static swiperInstances = new Map();
  static swiperFilesPromise = null;

  constructor(sliderElement) {
    this.element = sliderElement;
    this.options = this.parseConfig();
    this.setupEventListeners();

    if (this.options.observer) {
      this.initIntersectionObserver();
    } else {
      this.initializeSwiper();
    }
  }

  parseConfig() {
    const { dataset: { config, mobile, observer } } = this.element;

    try {
      return {
        config: JSON.parse(config),
        mobile: mobile === "true",
        observer: observer === "true"
      };
    } catch (error) {
      console.error("Error parsing slider configuration:", error);
      return { config: {}, mobile: false, observer: false };
    }
  }

  initializeSwiper() {
    if (this.shouldDisableSwiper()) {
      return;
    }
    if (!Swiper || !this.element || this.element.swiper) {
      return;
    }
    if (this.options.config.thumbs?.swiper) {
      const thumbsSelector = this.options.config.thumbs.swiper;
      const thumbsElement = document.querySelector(thumbsSelector);
      const thumbsInstance = SwiperConfigurator.swiperInstances.get(thumbsElement);

      if (!thumbsInstance) {
        setTimeout(() => this.initializeSwiper(), 0);
        return;
      }

      this.options.config.thumbs.swiper = thumbsInstance;
    }

    const instance = new Swiper(this.element, this.options.config);
    SwiperConfigurator.swiperInstances.set(this.element, instance)
  }

  shouldDisableSwiper() {
    return this.options.mobile && window.innerWidth > 768;
  }

  setupEventListeners() {
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  handleResize() {
    if (this.shouldDisableSwiper()) {
      this.destroySwiper();
    } else {
      this.initializeSwiper();
    }
  }

  destroySwiper() {
    if (this.element && this.element.swiper) {
      this.element.swiper.destroy(true, true);
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          console.log('Element is in view, initializing swiper');
          this.observer.disconnect();
          this.initializeSwiper();
        }
      });
    }, { threshold: 0.1 });

    this.observer.observe(this.element);
  }

  static appendTagToBody(tagType, filePath) {
    return new Promise((resolve, reject) => {
      const tag = document.createElement(tagType === 'script' ? 'script' : 'link');

      if (tagType === 'script') {
        tag.src = filePath;
        tag.type = 'text/javascript';
      } else if (tagType === 'style') {
        tag.href = filePath;
        tag.rel = 'stylesheet';
      } else {
        return reject(new Error('Unsupported tag type. Please use "script" or "style".'));
      }

      tag.onload = resolve;
      tag.onerror = () => reject(new Error(`Failed to load ${tagType} file: ${filePath}`));

      document.body.appendChild(tag);
    });
  }

  static appendSwiperFiles() {
    if (SwiperConfigurator.swiperFilesPromise) {
      return SwiperConfigurator.swiperFilesPromise;
    }
    const { css, js } = window.swiperFile || {};
    const files = [
      { type: 'style', path: css },
      { type: 'script', path: js },
    ].filter(file => file.path);

    if (files.length === 0) {
      SwiperConfigurator.swiperFilesPromise = Promise.resolve();
      return SwiperConfigurator.swiperFilesPromise;
    }
    const loadFilePromises = files.map(file => SwiperConfigurator.appendTagToBody(file.type, file.path));
    SwiperConfigurator.swiperFilesPromise = Promise.all(loadFilePromises);
    return SwiperConfigurator.swiperFilesPromise;
  }
}

const initSwipers = (root = document) => {
  const sliderElements = root.querySelectorAll("[data-slider-selector]");

  if (sliderElements.length > 0) {
    SwiperConfigurator.appendSwiperFiles()
      .then(() => {
        const sliders = Array.from(sliderElements)
          .filter(slider => !slider.hasAttribute('data-slider-ingredients'));
        const hasThumbs = (slider) =>
          typeof slider.dataset.config === 'string' &&
          slider.dataset.config.includes('"thumbs"');

        sliders
          .sort((a, b) => Number(hasThumbs(a)) - Number(hasThumbs(b)))
          .forEach((slider) => {
            if (slider.swiper || slider.dataset.swiperConfigured === 'true') return;
            slider.dataset.swiperConfigured = 'true';
            new SwiperConfigurator(slider);
          });
      }).catch((error) => {
        console.error('Failed to load Swiper files:', error);
      });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  initSwipers();
});

document.addEventListener('shopify:section:load', (event) => {
  initSwipers(event.target);
});

const initCountryCodeSync = () => {
  const updatePhoneCode = (select, input) => {
    if (!select || !input || !select.value) return;

    const selectedCode = select.value;
    const codeRegex = /^\+\d+\s?/;

    if (codeRegex.test(input.value)) {
      input.value = input.value.replace(codeRegex, selectedCode + ' ');
    } else {
      input.value = selectedCode + ' ' + input.value.trim();
    }
  };

  document.querySelectorAll('[data-country-select]').forEach(select => {
    const parent = select.closest('form') || select.closest('.footer-block__klaviyo');
    const phoneInput = parent?.querySelector('[data-phone-input]');

    if (select.value && phoneInput && phoneInput.value === '') {
      updatePhoneCode(select, phoneInput);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-country-select]');
    if (!select) return;

    const parent = select.closest('form') || select.closest('.footer-block__klaviyo');
    const phoneInput = parent?.querySelector('[data-phone-input]');

    updatePhoneCode(select, phoneInput);
    phoneInput?.focus();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountryCodeSync);
} else {
  initCountryCodeSync();
}

class MediaPlayer extends HTMLElement {
  constructor() {
    super();

    this.videoWrapper = this.closest(`.${this.getAttribute('data-video-wrapper')}`)

    this.video = this.querySelector('[data-role="video"]');
    this.button = this.querySelector(`.${this.getAttribute('data-video-button')}`);
    this.isMobile = window.innerWidth < 768;
  }

  connectedCallback() {
    if (!this.video) return;

    this.addEventListener("click", this.handleVideoClick.bind(this));
    this.video.addEventListener("play", this.handleVideoPlay.bind(this));
    this.video.addEventListener("pause", this.handleVideoPause.bind(this));
  }

  handleVideoClick() {
    if (!this.video.src && this.video.getAttribute('data-src')) {
      this.video.src = this.video.getAttribute('data-src');
      this.video.play();
    }

    const allVideoPlayers = this.closest(`.${this.getAttribute('data-video-wrapper')}`).querySelectorAll('media-player');

    allVideoPlayers.forEach(player => {
      if (player !== this && player.video && !player.video.paused) {
        player.video.pause();
        player.setAttribute("status", "paused");
      }
    });

    this.video.controls = true;

    if (this.isMobile) {
      this.firstClickHandled = true;
      this.button.setAttribute("is-mobile", "true");
    }

    this.video.blur();
    videoWrapper.focus({ preventScroll: true });
  }

  handleVideoPlay() {
    this.button.setAttribute("data-video", "play");
  }

  handleVideoPause() {
    this.button.setAttribute("data-video", "pause");
  }
}

customElements.define('media-player', MediaPlayer);

const initFooterKlaviyoForm = () => {
  const form = document.querySelector('#footer_klaviyo_form');
  if (!form) return;

  const companyId = form.querySelector('[name="company_id"]')?.value?.trim();
  const listId = form.querySelector('[name="list_id"]')?.value?.trim();
  if (!companyId || !listId) return;

  const successEl = form.querySelector('.klaviyo-status--success');
  const errorEl = form.querySelector('.klaviyo-status--error');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    successEl.style.display = 'none';
    errorEl.style.display = 'none';

    const fd = new FormData(form);
    const email = String(fd.get('email') || '').trim();
    const phone = String(fd.get('phone') || '').trim();
    const birthday = String(fd.get('birthday') || '').trim(); // YYYY-MM-DD if type=date

    const attributes = {
      email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
      properties: birthday ? { birthday } : undefined
    };
    if (phone) attributes.phone_number = phone.replaceAll(' ', ''); // profile field only (not SMS consent)

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Shopify footer custom form',
          profile: { data: { type: 'profile', attributes } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          revision: '2026-01-15'
        },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error(await res.text());
      form.reset();
      successEl.style.display = 'block';
    } catch (err) {
      console.error(err);
      errorEl.style.display = 'block';
    }
  });
};

document.addEventListener('DOMContentLoaded', initFooterKlaviyoForm);

class CustomSliderScrollbar extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.thumb = null;
    this.onScrollHandler = this.update.bind(this);
  }

  connectedCallback() {
    const targetId = this.getAttribute('data-target');
    this.container = targetId ? document.getElementById(targetId) : this.previousElementSibling;

    if (!this.container) return;

    this.container.style.scrollbarWidth = 'none';
    this.container.style.msOverflowStyle = 'none';
    this.container.classList.add('no-system-scrollbar');

    this.innerHTML = `
      <div class="custom-scrollbar__track">
        <div class="custom-scrollbar__thumb"></div>
      </div>
    `;

    this.thumb = this.querySelector('.custom-scrollbar__thumb');

    this.container.addEventListener('scroll', this.onScrollHandler);
    window.addEventListener('resize', this.onScrollHandler);

    setTimeout(() => this.update(), 100);
  }

  disconnectedCallback() {
    if (this.container) {
      this.container.removeEventListener('scroll', this.onScrollHandler);
    }
    window.removeEventListener('resize', this.onScrollHandler);
  }

  update() {
    if (!this.container || !this.thumb) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.container;

    if (scrollWidth > clientWidth + 1) {
      this.style.display = 'block';
      const trackWidth = this.querySelector('.custom-scrollbar__track').offsetWidth;
      let thumbWidth = (clientWidth / scrollWidth) * trackWidth;

      thumbWidth = Math.max(thumbWidth, 30);

      const maxScrollLeft = scrollWidth - clientWidth;
      const scrollPercentage = scrollLeft / maxScrollLeft;
      const maxTravel = trackWidth - thumbWidth;
      const translateX = scrollPercentage * maxTravel;

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${translateX}px)`;
    } else {
      this.style.display = 'none';
    }
  }
}

customElements.define('slider-scrollbar', CustomSliderScrollbar);



class SaleTimer extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const timerWrapperItem = this.querySelector("span");

    this.setAttribute("style", `--item-width: ${timerWrapperItem.offsetWidth}px`)

    this.endDate = new Date(this.dataset.endDate).getTime();

    this.intervalID = setInterval(this.updateCountdown.bind(this), 1000);
  }

  updateCountdown() {
    let now = new Date().getTime();
    const timeLeft = this.endDate - now;

    if (timeLeft <= 0) {
      clearInterval(this.intervalID);
      return
    }

    const days = Math.floor(timeLeft / (1e3 * 60 * 60 * 24))
      , hours = Math.floor(timeLeft % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60))
      , minutes = Math.floor(timeLeft % (1e3 * 60 * 60) / (1e3 * 60))
      , seconds = Math.floor(timeLeft % (1e3 * 60) / 1e3);

    this.querySelector("#days") && (this.querySelector("#days").innerHTML = `${days}`.length === 1 ? `0${days}` : days),
    this.querySelector("#hours") && (this.querySelector("#hours").innerHTML = `${hours}`.length === 1 ? `0${hours}` : hours),
    this.querySelector("#minutes") && (this.querySelector("#minutes").innerHTML = `${minutes}`.length == 1 ? `0${minutes}` : minutes),
    this.querySelector("#seconds") && (this.querySelector("#seconds").innerHTML = `${seconds}`.length === 1 ? `0${seconds}` : seconds)
  }
}

customElements.define('sale-timer', SaleTimer);


class Modal extends HTMLElement {
  constructor() {
    super();

    this._clickHandle = this.clickHandle.bind(this)
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  clickHandle(event) {
    if(event.target != this && !event.target.closest('[data-close]')) return;

    this.close();
  }

  show() {
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');

    setTimeout(() => {
      document.addEventListener('click', this._clickHandle)
    }, 0);
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');

    document.removeEventListener('click', this._clickHandle)
  }
}

customElements.define('modal-element', Modal);

class DeliveryDate extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const today = new Date();
    const currentHour = today.getHours();
    const dayOfWeekIndex = today.getDay();
    
    const cutoffHour = 14;
    const isAfterCutoffTime = currentHour >= cutoffHour;

    const deliveryScheduleMap = {
      1: [2, 3], // Monday
      2: [2, 3], // Tuesday
      3: [2, 5], // Wednesday
      4: [4, 5], // Thursday
      5: [4, 5], // Friday
      6: [4, 4], // Saturday
      0: [3, 3], // Sunday
    };

    const timeSlotIndex = isAfterCutoffTime ? 1 : 0;
    const daysToWait = deliveryScheduleMap[dayOfWeekIndex][timeSlotIndex];

    const finalDeliveryDate = new Date(today);
    finalDeliveryDate.setDate(today.getDate() + daysToWait);

    this.innerHTML = this.formatDateInEnglish(finalDeliveryDate);
  }

  formatDateInEnglish(date) {
    const dayName = new Intl.DateTimeFormat('en-US', { 
      weekday: 'long' 
    }).format(date);

    const monthName = new Intl.DateTimeFormat('en-US', { 
      month: 'short' 
    }).format(date);
    
    const dayOfMonth = date.getDate();

    const getOrdinalSuffix = (day) => {
      if (day >= 11 && day <= 13) {
        return "th";
      }

      const lastDigit = day % 10;
      switch (lastDigit) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    };

    const suffix = getOrdinalSuffix(dayOfMonth);

    return `${dayName}, ${dayOfMonth}${suffix} ${monthName}`;
  }
}

customElements.define('delivery-date', DeliveryDate);

class DragScroll extends HTMLElement {
  connectedCallback() {

    let isDown = false, startX, scrollLeft;
    let velX = 0, lastX, animId;
    let didDrag = false;

    const disableSmooth = () => {
      this.style.scrollSnapType = 'none';
      this.style.scrollBehavior = 'auto';
    };

    const restoreSmooth = () => {
      this.style.scrollSnapType = '';
      this.style.scrollBehavior = '';
    };

    this.addEventListener('mousedown', e => {
      isDown = true;
      didDrag = false;
      startX = e.pageX - this.offsetLeft;
      scrollLeft = this.scrollLeft;
      velX = 0;
      lastX = e.pageX;
      this.style.cursor = 'grabbing';
      disableSmooth();
      e.preventDefault();
    });

    document.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      this.style.cursor = 'grab';
      restoreSmooth();
    });

    document.addEventListener('mousemove', e => {
      if (!isDown) return;
      const dx = e.pageX - this.offsetLeft - startX;
      if (Math.abs(dx) > 4) didDrag = true;
      velX = e.pageX - lastX;
      lastX = e.pageX;
      this.scrollLeft = scrollLeft - dx;
    });

    this.addEventListener('click', e => {
      if (didDrag) e.preventDefault();
    });
  }
}

customElements.define('drag-scroll', DragScroll);